<jhi-alert></jhi-alert>
<jhi-spinner *ngIf="loading"></jhi-spinner>
<div class="col-xl card-pg">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="card-body">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span
              class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToServizi()">Servizi</a><span
              class="separator">/</span></li>
            <li class="breadcrumb-item" *ngFor="let breadcrumbItem of funzioneServizio.breadcrumbs"><a href="{{breadcrumbItem.url}}">{{breadcrumbItem.label}}</a><span class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Pagare {{paymentNoticesService.mapCodiceTributo.get(cdTributo)}}</a></li>
          </ol>
        </nav>
        <h2 class="text-center">Pagare {{paymentNoticesService.mapCodiceTributo.get(cdTributo)}}</h2>
        <div class="row">
          <div class="col-12 text-center">
           <div class="steppers">
          <div class="steppers-header">
            <ul>
              <li  [class]="stepIndex == 0 ? 'active' : 'confirmed'">Informativa sulla privacy </li>
              <li  [class]="stepIndex == 1 ? 'active' : stepIndex > 1 ? 'confirmed': ''">Dati generali</li>
              <li  [class]="stepIndex == 2 ? 'active' : stepIndex > 2 ? 'confirmed': ''">Dati pagamento</li>
            </ul>
            <span class="steppers-index" aria-hidden="true">{{stepIndex + 1}}/3</span>
          </div>
        </div>
          </div>
        </div>
        <!-- <form [formGroup]="formFilter" class="d-flex justify-content-end">
          <div class="d-flex justify-content-end container-fluid">
            <button class="btn btn-primary primary-button btn-icon" data-bs-toggle="dropdown">
              <svg class="icon icon-white ms-1">
                <use href="./content/svg/sprites.svg#it-funnel"></use>
              </svg>
              <span><span jhiTranslate="istanze.filtra.titolo">Filtra</span><span *ngIf="countFiltri != 0"> ({{ countFiltri }})</span></span>
            </button>
            <div class="dropdown-menu dismissible w-50" role="menu">
              <div class="container-fluid my-2">
                <div class="row justify-content-between mb-2">
                  <div class="col">
                    <h5 class="fw-bold">Filtra ricerca</h5>
                  </div>
                  <div class="col">
                    <button type="button" class="btn-close float-end" data-bs-dismiss="menu"
                            aria-label="Chiudi avviso"></button>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-6">
                    <div>
                      <label for="selectStato" jhiTranslate="istanze.stato">Stato</label>
                      <div class="select-wrapper">
                        <select id="selectStato" formControlName="stato">
                          <option selected="" [ngValue]="null">Tutti gli stati</option>
                          <option value="Pagato">Pagato</option>
                          <option value="Da pagare">Da pagare</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6" *ngIf="isIuvPresent">
                    <label for="iuv">Iuv</label>
                    <div class="form-group">
                    <input type="text" id="iuv" formControlName="iuv" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-4 mb-1">
                    <button class="btn btn-primary primary-button btn-xs btn-me w-100" type="button"
                            (click)="applicaFiltri()">
                      <span>Applica</span>
                    </button>
                  </div>
                  <div class="col-lg-4 mb-1">
                    <button class="btn btn-danger btn-xs btn-me w-100" type="button"
                            (click)="$event.stopPropagation();removeFilters()">
                      <span>Rimuovi</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form> -->
        <div *ngIf="stepIndex == 0">
          <div class="row justify-content-center mb-3 mt-2">
            <div class="col-12 col-lg-8 pb-40 pb-lg-80">
              <p class="text-paragraph mb-lg-4">
                Il Comune di <span *ngIf="confService.configurazione">{{confService.configurazione.nome}}</span> gestisce i dati personali forniti e liberamente comunicati sulla base dell’articolo 13 del Regolamento (UE) 2016/679 General data protection regulation (Gdpr) e degli articoli 13 e successive modifiche e integrazione del decreto legislativo (di seguito d.lgs) 267/2000 (Testo unico enti locali).
              </p>
              <p class="text-paragraph mb-0">
                Per i dettagli sul trattamento dei dati personali consulta l’
                <a *ngIf="confService.configurazione" [attr.href]="confService.configurazione.linkPrivacy" class="t-primary">informativa sulla privacy.</a>
              </p>

              <div class="form-check mt-4 mb-3 mt-md-40 mb-lg-40">
                <div class="checkbox-body d-flex align-items-center">
                  <input type="checkbox" id="privacy" name="privacy-field" value="privacy-field" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}">
                  <label class="title-small-semi-bold pt-1" for="privacy">Ho letto e compreso l’informativa sulla privacy</label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-primary mobile-full background-primary" [disabled]="!isChecked" (click)="stepIndex = 1">
                <span class="">Avanti</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="stepIndex == 1">
          <h4>Effettuato da: </h4>
          <p>Informazioni sulla persona che effettua il pagamento.</p>
          <div class="row mt-5">
            <div class="col-lg-4">
              <div class="form-group">
                <label class="active" for="nome">Nome</label>
                <input id="nome" type="text" class="form-control" disabled value="{{userData.nome}}">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label class="active" for="cognome">Cognome</label>
                <input id="cognome" type="text" class="form-control" disabled value="{{userData.cognome}}">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label class="active" for="cf">Codice fiscale</label>
                <input id="cf" type="text" class="form-control" disabled value="{{userData.cf}}">
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-1">
              <div class="form-group">
                <label class="active" for="dataNascita">Data di nascita</label>
                <input id="dataNascita" type="text" class="form-control" disabled value="{{userData.dataDiNascita | date : 'dd/MM/yyyy'}}">
              </div>
            </div>
            <div class="col-lg-5">
              <div class="form-group">
                <label class="active" for="indirizzo">Indirizzo</label>
                <input id="indirizzo" type="text" class="form-control" disabled value="{{userData.indirizzo || '-'}}">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="active" for="email">Email</label>
                <input id="email" type="text" class="form-control" disabled value="{{userData.email}}">
              </div>
            </div>
          </div>
          <div class="mt-1">
            <div class="d-flex w-100 justify-content-between">
              <button type="button" class="btn btn-primary mobile-full background-primary" (click)="stepIndex = 0">
                <span class="">Indietro</span>
              </button>
              <button type="button" class="btn btn-primary mobile-full background-primary" (click)="goToSelezionaPagamento()">
                <span class="">Avanti</span>
              </button>
            </div>
          </div>
        </div>
        <form [formGroup]="formFilter" *ngIf="stepIndex == 2">
          <div class="container-fluid my-2" style="min-height: 400px" *ngIf="this.listaPagamenti.length !== 0">
            <h6>Seleziona il pagamento: </h6>
            <div class="select-wrapper">
              <select class="select-pagamento" (change)="goToDettaglioPagamento($event)">
                <option [defaultSelected]="true">Seleziona un pagamento</option>
                <option *ngFor="let pg of listaPagamenti" value="{{pg.Iuv}}">{{pg.Iuv}} - {{pg.Descrizione}} ( {{pg.Data | date: 'dd/MM/yyyy'}} )</option>
              </select>
            </div>
            <jhi-dettaglio-pagamento-tributi *ngIf="pagamentoSelezionato"></jhi-dettaglio-pagamento-tributi>
          </div>
          <div class="container-fluid text-center my-2" style="min-height: 400px" *ngIf="listaPagamenti.length == 0 && !loading">
            <div class="card-wrapper mt-3 d-flex justify-content-center" style="padding-bottom: 0; ">
              <div class="card card-bg border-bottom-card p-2 background-primary-before">
                <div style="margin-top: 4rem">
                  <h3 class="fw-bold" style="margin-bottom: 3rem" >Non ci sono
                    pagamenti.</h3>
                  <h4>Al momento non sono stati rilevati pagamenti.</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-1">
            <div class="d-flex w-100 justify-content-between">
              <button type="button" class="btn btn-primary mobile-full background-primary" (click)="stepIndex = 1">
                <span class="">Indietro</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
